export default __webpack_public_path__ + "520bdd4d43dc4be3e709bfad5aeee1e0.svg";